<template>

<div id="searchandresults">
    <div class="searchbox">
      <div class="searchboxInner">
        <input v-model="searchQuery"  @input="onChange" id="searchQuery" type="text">
        <button class="searchbutton" v-if="searchQuery != '' " v-on:click="resetSearch">Suchen</button>      
      </div>
        <router-link tag="button" class="addbutton" v-bind:to="{ name: 'NewContact'}">Hinzufügen</router-link>      
    </div>


    <div class="listview">
      <div class="columns">
        <div class="column">
          <a href="#!" class="setListView" v-bind:class="!kachel ? 'active' : ''" v-on:click="setListView">Liste-Ansicht</a>
          <a href="#!" class="setGridView" v-bind:class="!kachel ? '' : 'active'" v-on:click="setGridView">Kachel-Ansicht</a>
        </div>

        <div class="column">
<!--
          <a href="#!" class="showAll switchresult" v-bind:class="show == 1 ? 'active' : ''" v-on:click="showChange(1)">Alle</a>
          <a href="#!" class="showCompanies switchresult" v-bind:class="show == 2 ? 'active' : ''" v-on:click="showChange(2)">Nur Firmen</a>
          <a href="#!" class="showPersons switchresult" v-bind:class="show == 3 ? 'active' : ''" v-on:click="showChange(3)">Nur Personen</a>
-->
          <a href="#!" class="showTyp switchresult" v-bind:class="showTyp == 'a' ? 'active' : ''" v-on:click="showTypChange('a')">Alle</a>
          <a href="#!" class="showTyp switchresult" v-bind:class="showTyp == 'i' ? 'active' : ''" v-on:click="showTypChange('i')">Büro</a>
          <a href="#!" class="showTyp switchresult" v-bind:class="showTyp == 'e' ? 'active' : ''" v-on:click="showTypChange('e')">Gewerblich</a>
    
        </div>

      </div>
    </div>

      <div class="columns" v-if="results.length < 1 ">
        <div class="column">
           <span class="aligncenter">Keine Ergebnisse</span>
        </div>
      </div>

    
    <div class="autocomplete-results" v-bind:class=" !kachel ? 'listview' : 'gridview' ">
      

       <div class="user-list autocomplete-result" v-for="(result, i) in results" :key="i" v-on:click="setResult(result)">
          
          
          <router-link v-bind:to="{ name:  (!result.companyid && result.company ? 'ViewCompany':'ViewContact'), params: { contact: result.slug }}" class="columns contact">
            <div class="column">
              <span class="block user-list__header" v-if=" result.company "><strong>{{result.company}}</strong></span>
              <span class="block user-list__header" v-if=" result.lastname "><strong>{{result.firstname}} {{result.lastname}}</strong></span>              
              <span class="block user-list__header" v-if=" kachel && result.phonenumber ">{{result.phonenumber}}</span>              
              <span class="block user-list__header" v-if=" kachel && result.emailaddress ">{{result.emailaddress}}</span>              
              
              <span v-if=" kachel && !result.companyid">
                <span class="block user-list__header" v-if=" kachel && result.companyaddress">{{result.companyaddress}}<br>
                <span class="user-list__header" v-if=" kachel && result.companycity">{{result.companyzipcode}} {{result.companycity}}</span></span>
              </span>
              <span v-if=" kachel && !result.companyid">
                <span class=" block user-list__header" v-if=" kachel && result.companyphonenumber">{{result.companyphonenumber}}<br></span>
                <span class=" block user-list__header" v-if=" kachel && result.companyemailaddress">{{result.companyemailaddress}} {{result.companyemailaddress}}</span>
              </span>
            </div>
            <div class="column right">
              <span class="button icon icon-chevron-right" >View Person</span>
            </div>
          </router-link>
          
          
        </div>
    </div>
</div> 
</template>
<script>
  export default {
    name: 'Search',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      isAsync: {
        type: Boolean,
        required: false,
        default: false,
      },
    },    
    data: function(){
      return {
         searchQuery: '',
         results: [],
         isOpen: false,
         isLoading: false,
         arrowCounter: -1,
         kachel: true,
         show: 1,
         showTyp: 'a'
      }
    },
    methods:{
      resetSearch: function(){
        this.searchQuery = ""
        this.filterResults()
        
      },
      
      setListView: function(){
        this.kachel = false;
      },
      setGridView: function(){
        this.kachel = true;
      },

      showChange: function(w) {
        this.show = w;
        this.filterResults()
        //console.log(w)
      },
      showTypChange: function(w){
        this.showTyp = w
        this.filterResults()
      },

      submitSearch: function(){
        //alert('search ' + this.searchQuery);
      },
    
    
      onChange() {
        // Let's warn the parent that a change was made
        this.$emit('input', this.searchQuery );

        // Is the data given by an outside ajax request?
        if (this.isAsync) {
          this.isLoading = true;
        } else {
          // Let's  our flat array
          this.filterResults();
          this.isOpen = true;
        }
      },

      filterResults() {
        // first uncapitalize all the things
        switch(this.searchQuery.toLowerCase()) {
          
          
          case 'spritzen':
          this.results = this.items.filter((item) => {
                  return ( item.spritzen > 0  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          
          case 'mauern':
          this.results = this.items.filter((item) => {
                  return ( item.mauern > 0  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 
          
          case 'faser':
          this.results = this.items.filter((item) => {
                  return ( item.faser > 0  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 
          
          
                                        
          case 'engl':
          this.results = this.items.filter((item) => {
                  return ( item.engl === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'englisch':
          this.results = this.items.filter((item) => {
                  return ( item.engl === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'kran':
          this.results = this.items.filter((item) => {
                  return ( item.kran === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'sivv':
          this.results = this.items.filter((item) => {
                  return ( item.sivv === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'sibe':
          this.results = this.items.filter((item) => {
                  return ( item.sibe === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 


          case 'winde':
          this.results = this.items.filter((item) => {
                  return ( item.winde === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'eh':
          this.results = this.items.filter((item) => {
                  return ( item.eh === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'dat':
          this.results = this.items.filter((item) => {
                  return ( item.dat === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 

          case 'stapler':
          this.results = this.items.filter((item) => {
                  return ( item.stapler === true  ) && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
                  })
          break 



          default:        
          this.results = this.items.filter((item) => {
            return (
              
              (item.company && item.company.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)
              || 
              (item.companyaddress && item.companyaddress.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1 )
              ||
              (item.firstname && item.firstname.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)
              ||
              (item.lastname && item.lastname.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)
              ||
              (item.vers && item.vers.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)
              ||
              (item.versnr && item.versnr.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)
              ||
              (item.birthday && item.birthday.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1)

              
              ) 
              && 
              (!item.companyid && item.company && ( this.show == 2 ) 
              || ( (item.companyid || !item.company ) && ( this.show == 3 ) ) 
              || this.show == 1 
              )
              && 
              (  ( item.typ && item.typ == 'i' &&  this.showTyp == 'i' ) 
              || ( item.typ && item.typ == 'e' && this.showTyp == 'e' ) 
              || ( this.showTyp == 'a' )
              )
          });
          
        } // end swicth
          
      },
      setResult(result) {
        this.searchQuery = result;
        this.isOpen = false;
      },
      onArrowDown(evt) {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter -1;
        }
      },
      onEnter() {
        this.searchQuery = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      }
     
    
    
    },      
    watch: {
      items: function (val, oldValue) {
        // actually compare them
        if (val.length !== oldValue.length) {
          this.results = val;
          this.isLoading = false;
        }
      },
    },      
    mounted: function(){
      document.getElementById("searchQuery").focus();
      document.addEventListener('click', this.handleClickOutside)
      console.log( this.items );
      this.results = this.items
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    }
  }
</script>
<style>
  
  #searchandresults { padding: 5rem 0 0 0; }
  #searchandresults .block { padding: 0.43333em 0; margin: 0; display: block; }
  #searchandresults .searchbox { position: fixed; z-index: 9; border-top: 0 solid #d8d8d9; border-bottom: 1px solid #d8d8d9; padding: 0.3333333em; left: 0; right: 0; top: 3.33333em; background: #fff;  }

@media screen and (min-width: 768px) {
  #searchandresults .searchbox { display: flex; align-items: center; justify-content: center; }
}
  #searchandresults .searchboxInner { width: 100%; position: relative; max-width: 30em; margin: 0 1em 0 0; display: flex; }
  #searchandresults #searchQuery {  margin: 0; padding: 0.43333em 0.93333em 0.43333em 3.13333em !important; width: 100%; background: transparent url(../assets/icons/search.svg) 0.73333em center no-repeat; background-size: 1.6333333em; }
  
  #searchandresults p.aligncenter { text-align: center; }
  
  #searchandresults .searchbutton { border: 0; padding: 0; margin: 0; background: transparent url(../assets/icons/close.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -99999px; height: 1.4333333em; line-height: 1.43333333em; width: 1.83333333em; outline: none;
    position: absolute; right: 0.593333333em; top: 0.493333333em; transition: background-color 0.3s ease-out; border-radius: 3px; }
  #searchandresults .searchbutton:hover, .searchbutton:focus { background-color: #e9e9e8; }  

  #searchandresults .addbutton { display: inline-block; border: 0; padding: 0; margin: 0.43333em 0; background: transparent url(../assets/icons/add.svg) left center no-repeat; background-size: 1.6333333em; padding-left: 2.1333em; height: 1.8333333em; line-height: 1.83333333em; outline: none; cursor: pointer; }

  #searchandresults .autocomplete-results { width: 100%; max-width: 44em; margin: 0 auto; }
  #searchandresults .user-list { text-align: left; }
  #searchandresults .icon { display: inline-block; width: 2.1333333em; height: 2.133333333em; line-height: 2.133333333em; padding: 0; margin: 0; border: 0; text-indent: -9999px; }  
  #searchandresults .icon:hover { background-color: #fff; }
  #searchandresults .icon-chevron-right { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 2.133333333em; }
  #searchandresults .icon-chevron-right:hover { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 2.133333333em; }
  #searchandresults .user-list .columns { padding: 0; display: flex;  justify-content: space-between; align-items: stretch; max-width: 100%;  }
  #searchandresults .user-list .column { padding: 0; }
/*   #searchandresults .user-list  { padding: 0.57333333em 0 0.3333333em; margin: 0; background: none;} */
  #searchandresults .column.right { width: 2.13333333em; align-self: flex-end; }
  #searchandresults .contact { padding: 0.4333333em 0 0.43333333em 0.433333333em; border: 1px solid #eee; border-bottom-color: transparent; border-left-color: transparent; border-right-color: transparent; color: #232323; text-decoration: none; transition: width 0.3s, height 0.3s, border 0.3s ease-in-out, border-radius 0.3s ease-in-out; outline: 0 !important; }
  #searchandresults .user-list:first-child .contact { border-top-color: transparent; }
  #searchandresults .contact:hover, 
  #searchandresults .contact:focus { border: 1px solid #00aeff !important; border-radius: 3px; }
  #searchandresults .contact:hover + .contact { border-color: transparent !important; }
  
  #searchandresults .listview .columns { display: flex; align-items: center; justify-content:space-between; max-width: 44em; margin: 0 auto; }
  #searchandresults .listview .columns .column { padding: 0.93333em 0; }
  
  #searchandresults .listview .columns.contact .column { padding: 0; }
  
  #searchandresults .switchresult { color: #89898a; text-decoration: none; display: block; padding: 0 0.2333em; transition: color 0.3s; }
  #searchandresults .switchresult:hover { color: #343435; }
  #searchandresults .switchresult.active { color: #00aeff; }
  
  #searchandresults .setListView { display: inline-block; padding: 0.433333em; background: url(../assets/icons/list.svg) center center no-repeat; background-size: 2.2333333em; text-indent: -99999px; height: 2.0333333em; line-height: 1.83333333em; width: 2.03333333em; outline: none; border: 1px solid #eee; border-radius: 3px;}
  #searchandresults .setGridView { display: inline-block; padding: 0.433333em; background: url(../assets/icons/grid.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -99999px; height: 2.0333333em; line-height: 1.83333333em; width: 2.03333333em; outline: none; border: 1px solid #eee; border-radius: 3px;}
  #searchandresults .setListView.active, 
  #searchandresults .setGridView.active { border-color: #00aeff; }

  #searchandresults .gridview { display: inline-grid; grid-template-columns: 100%; grid-column-gap: 10px; grid-row-gap: 10px; }
  #searchandresults .gridview .autocomplete-result .contact { border: 1px solid #ccc; border-radius: 3px; }

@media screen and (min-width: 768px) {
  #searchandresults .gridview { display: inline-grid; grid-template-columns: 50% 50%; grid-column-gap: 10px; grid-row-gap: 10px; }
  #searchandresults .switchresult {display: inline-block;}
}
</style>


// WEBPACK FOOTER //
// src/components/Search.vue